import { Action } from 'redux';
import { RootState } from '.';
import { useSelector } from 'react-redux';

export const THEME = 'THEME';

var theme = localStorage.getItem("theme");

const initialState: string = theme || 'light';

export interface ThemeAction extends Action {
    type: typeof THEME;
    payload: string;
}

export function changeThemeAction(theme: string): ThemeAction {
    localStorage.setItem('theme', theme);
    return {
        type: THEME,
        payload: theme
    };
}

export function themeReducer(state = initialState, action: ThemeAction): string {
    switch (action.type) {
        case THEME:
            return action.payload;
        default:
            return state;
    }
}

export function useCbxTheme(): string {
    const themeLocalStorage = localStorage.getItem('theme');
    const themeRedux = useSelector((root: RootState) => root.theme);
    return themeLocalStorage ? themeLocalStorage : themeRedux;
}